<div *ngFor="let key of keysOfErrors" class="msg" role="alert" [hidden]="(key === 'minValue' && control?.errors?.min) || (key === 'maxValue' && control?.errors?.max)">
  <span class="font-medium">
    <span *ngIf="valideMax" [translatable]="{
        transKey: 'shared.validations.' + key,
        modEnum: translationModulesEnum.shared
      }">
      {{ "shared.validations." + key | translate }}
    </span>
    <span *ngIf="!valideMax">
      {{ "shared.validations.validateMinPercentage." + key | translate }}
    </span>
    <span *ngIf="key == 'maxlength'">
      {{ maxLength }}
    </span>

    <span *ngIf="key == 'minlength'">
      {{ minLength }}
    </span>

    <span *ngIf="key == 'min'">
      {{ minValue != null ? minValue : minValueNew }}
    </span>

    <span *ngIf="key == 'max'">
      {{ control?.errors?.max?.max != null ? control?.errors?.max?.max : (maxValue != null ? maxValue : maxValueNew) }}
    </span>
    <span *ngIf="key == 'maxValue'">
      {{ maxValue != null ? maxValue : maxValueNew }}
    </span>
  </span>
</div>